import { EventEmitter } from "@angular/core";

export class EventEmitterService {

    private static emitters: {
        [nomeEvento: string]: EventEmitter<any>
    } = {}

    static get(nomeEvento: string): EventEmitter<any> {
        if (!this.emitters[nomeEvento])
            this.emitters[nomeEvento] = new EventEmitter<any>();

        return this.emitters[nomeEvento];
    }

    static avisos(): EventEmitter<any> {
        return EventEmitterService.get('avisos');
    }

    static buscaProdutos(): EventEmitter<any> {
        return EventEmitterService.get('busca.produtos');
    }

    static buscaTabelasPreco(): EventEmitter<any> {
        return EventEmitterService.get('busca.tabelaPreco');
    }

    static buscaCondicoesPagamento(): EventEmitter<any> {
        return EventEmitterService.get('busca.condicoesPagamento');
    }

    static buscaPedidos(): EventEmitter<any> {
        return EventEmitterService.get('busca.pedidos');
    }
    
    static atualizarPrevisao(): EventEmitter<any> {
        return EventEmitterService.get('previsao.atualizar');
    }
}
